import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const PaymentsFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 200)
      } else {
         setVisible(false)
      }
   }, [active])

   return (
      <div className="w-full h-full">
         <div
            className={classNames(
               'absolute top-[12%] left-[15%] w-[70%] p-2 bg-white rounded-3xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700',
               visible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
            )}>
            <img
               className="w-full"
               src="/assets/custom/communities/images/features/payments/1.jpg"
               alt="Payments"
            />
         </div>
      </div>
   )
}

PaymentsFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default PaymentsFeature
